import { call, put, takeLatest } from 'redux-saga/effects';
import { FETCH_OVERVIEW_DATA_INIT } from './constants';
import { fetchOverviewSuccess, fetchOverviewFailure } from './actions';
import { fetchCustomerOverviewData } from './service';


function* fetchOverviewDataSaga({payload}) {
    try {
      const response = yield call(fetchCustomerOverviewData, payload);
      yield put(fetchOverviewSuccess(response));
    } catch (error) {
      yield put(fetchOverviewFailure(error));
    }
  }
  
  function* watchFetchOverviewData() {
    yield takeLatest(FETCH_OVERVIEW_DATA_INIT, fetchOverviewDataSaga);
  }
  
  export default watchFetchOverviewData;